<template>
    <div class="video-item relative">

        <div v-if="!video.grantaccess && godview" class="text-red-600 text-center bg-yellow-200 py-2">
            🔐 This is a locked video. You can watch it as a {{ $page.props.app_name }}’ team member.
        </div>

        <a href="#" @click.prevent="clickVideo"
            :class="['video-box flex relative overflow-hidden pb-16/9 mx rounded-none sm:rounded-lg shadow-md bg-gray-900 text-white']">


            <div class="flex">

                <video-player ref="videoPlayer" v-if="video.grantaccess || godview" class="vjs-custom-skin"
                    :options="playerOptions" @play="onPlayerPlay($event)" @playing="onPlayerPlaying($event)"
                    @ready="onPlayerReady($event)" @pause="onPlayerPause($event)" @ended="onPlayerEnd($event)"
                    @timeupdate="onTimeUpdate($event)" :trim_offset="trim_offset">
                </video-player>


                <div v-if="!video.grantaccess && !godview" class="absolute w-full h-full img blur " :key="video_thumb"
                    :style="'background-image:url(' + fullPathFor(video_thumb) + ');filter:blur(3px);'">
                </div>

                <div v-if="state == 'ready' && video_gif" class="absolute w-full h-full img gif" :key="video_gif"
                    :style="'background-image:url(' + fullPathFor(video_gif) + ')'">
                    <div class="gif-overlay"></div>
                </div>

                <div v-else-if="state == 'ready' && video_thumb" class="absolute w-full h-full img gif"
                    :style="'background-image:url(' + fullPathFor(video_thumb) + ')'" :key="'thumb-' + video_thumb">
                    <div class="gif-overlay"></div>
                </div>

                <div v-if="state == 'ready'" ref="videoButtonPlay" class="play">
                </div>




                <transition name="fade">
                    <div class="absolute w-full h-full flex flex-col justify-center align-center bg-gray-800 bg-opacity-70 "
                        v-if="copied">
                        <div class="text-center text-sm font-semibold">Link Copied!</div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="absolute w-full h-full flex flex-col justify-center align-center bg-gray-800 bg-opacity-70 pointer-events-none"
                        v-if="waiting_download">
                        <div
                            class="flex flex-col items-center text-center text-base rounded-lg p-8 bg-gray-900 mx-auto">
                            Wait a few seconds, <br />
                            <spinner class="mx-auto h-5 w-5 text-white my-4"></spinner>
                            download is starting…
                        </div>
                    </div>
                </transition>


                <div class="absolute w-full h-full flex flex-col justify-center items-center pointer-events-none"
                    v-if="video.grantaccess">
                    <img class="video-playpause-overlay" :class="{ 'show': state == 'playing' }" ref="play"
                        src="/img/play-rounded-overlay.svg" />
                    <img class="video-playpause-overlay" :class="{ 'show': state == 'paused' }" ref="pause"
                        src="/img/pause-rounded-overlay.svg" />
                </div>

            </div>

        </a>

        <div v-if="!video.grantaccess && is_visitor" class="lockedMsg">
            This video can't be watched right now, monthly limit has been reached.<br />Workspace admins have been
            notified.
        </div>

        <div v-else-if="!video.grantaccess && !is_visitor && !godview && team_owner_email != ''" class="lockedMsg">
            <span v-if="!$page.props.canManagePlan">Monthly limit has been reached. <a :href="mailtoOwnerLink">Notify
                    workspace admins</a> to
                upgrade.</span>
            <span v-else>Monthly limit has been reached. <a :href="route('subscription.index')">Upgrade</a> to
                unlock videos.</span>
        </div>

    </div>
</template>



<script>

import VideoPlayer from './VideoPlayer.vue'
import Spinner from '@/Components/UI/Spinner'
import moment from 'moment-timezone';


export default {

    props: ['is_visitor', 'the_video', 'the_team_slug', 'is_godview', 'team_owner_email', 'team_admins', 'datacenter', 'video_full_width', 'trim_offset', 'video_gif', 'video_thumb'],

    components: {
        VideoPlayer, Spinner
    },

    created: function () {
        this.EventBus.on('copied', () => {
            //let link = this.$page.props.app_url + '/share/' + this.video.uuid;
            //this.$copyText(link);
            this.copied = true;
            let timeout_message = setTimeout(function () {
                this.copied = false;
            }.bind(this), 1000);
        });
        this.EventBus.on('download', () => {
            this.action_download_wait()
        });
        this.EventBus.on('download_test', (arg) => {
            this.action_download_test(arg)
        });
        // this.EventBus.on('viewed', () => {
        //     this.alreadyReadCount = true;
        // });
        window.addEventListener('blur', (event) => {
            this.waiting_download = false;
        });



        // if (!this.video.video_file || !this.video.image_thumb) {
        //   setTimeout(function(){
        //     this.reload_video();
        //   }.bind(this), 500);
        // } else {
        //   this.video_loaded = true;
        // }

        this.EventBus.on('videoseek', (time) => {
            this.clickVideo(time)
        })

        this.moment = moment;

        if (this.the_video.start_timestamp && this.the_video.stop_timestamp) {
            this.video_initial_duration = Math.round(this.moment(this.the_video.stop_timestamp).diff(this.moment(this.the_video.start_timestamp)) / 1000);
        }
        if (this.the_video.video_length) {
            this.video_known_duration = Math.round(this.the_video.video_length / 1000);
        } else if (this.the_video.start_timestamp && this.the_video.stop_timestamp) {
            this.video_known_duration = this.video_initial_duration;
        }

        // console.log("THE VIDEO / CREATED", this.the_video)
        // console.log("video_known_duration", this.video_known_duration)

    },

    beforeUnmount() {
        this.EventBus.off('copied');
        this.EventBus.off('download');
        this.EventBus.off('download_test');
        // this.EventBus.off('viewed');
        this.EventBus.off('videoseek');
    },

    data() {
        return {
            //teamslug: '',
            // Faster acceerated S3
            s3: this.datacenter + '/videos',
            playerOptions: {
                preload: false,
                autoplay: false,
                controls: true,
                controlBar: {
                    timeDivider: false,
                    durationDisplay: true
                }
            },
            state: '',
            video: this.the_video,
            //userViewed: false,
            copied: false,
            waiting_download: false,
            alreadyReadCount: false,
            godview: this.is_godview | false,
            visitor: this.the_video.uuid != this.the_video.uuid_secondary,
            video_loaded: true, //false,
            video_error: false,
            transcoding_error: false,
            is_play: false,
            is_pause: false,
            isActivated: false,
            moment: {},
            video_known_duration: 0,
            video_loaded_duration: null,
            can_play: true,
            video_initial_duration: 0
            // textDetector: {}
        }
    },

    mounted: function () {
        // this.textDetector = new TextDetector();

    },

    methods: {

        fullPathFor: function (filename) {
            if (!filename) {
                return '';
            }
            if (filename.startsWith('http')) {
                return filename;
            }
            return this.s3 + '/' + this.teamslug + '/' + filename;
            //return Spark.app_url + '/file/' + this.teamslug + '/' + filename;
        },
        // fullPathForBlur: function(filename) {
        //     return this.$page.props.app_url + '/fileb/' + this.teamslug + '/' + filename;
        // },
        onPlayerPlay: function (player) {
            this.state = 'play';
            if (!this.alreadyReadCount) {
                this.updateViews()
            }
        },
        onPlayerPlaying: function (player) {
            this.state = 'playing';
            // if (!this.alreadyReadCount && (this.$page.props.user != null || this.video.user)) {
            //     this.updateViews();
            //     console.log("onPlayerPlaying")
            //
            // let capturer = new ImageCapture(theStream.getVideoTracks()[0]);
            // capturer.grabFrame().then(frame => {
            //     this.searchText(frame)
            // })
            // }
        },
        onPlayerReady: function (player) {
            this.state = 'ready';
        },
        onPlayerPause: function (player) {
            //console.log("onPlayerPause")
            this.state = 'paused';
        },
        onPlayerEnd: function (player) {
            //console.log("onPlayerEnd")
            this.state = 'ended';
            if (!this.alreadyReadCount) {
                this.updateViews()
            }
        },
        onTimeUpdate: function (player) {
            //console.log("onTimeUpdate", player.currentTime(), player.duration())
            if (!this.alreadyReadCount) {
                if (player.currentTime() >= 5 || player.currentTime() / player.duration() >= 0.75) {
                    this.updateViews()
                }
            }
            this.EventBus.emit("consoletimeupdate", player.currentTime())
        },
        clickVideo: async function (seekTo = null) {
            if (!this.video.grantaccess && !this.godview || this.waiting_download) {
                return;
            }

            // Normalize seekTo value
            if (typeof seekTo === 'object') {
                seekTo = null;
            } else if (typeof seekTo === 'number' && !isNaN(seekTo)) {
                seekTo = Math.max(0, seekTo); // Ensure seekTo is not negative
            } else {
                seekTo = null;
            }

            this.$emit('play_started')

            if (!this.video_loaded || this.isActivated) {
                if (seekTo !== null) {
                    this.player.currentTime(seekTo);
                }
                return;
            }

            if (this.state == 'play') {
                this.reset();
                return;
            } else if (this.state == 'playing') {
                this.player.pause();
                return;
            } else if (this.state == 'paused') {
                this.player.play();
                return;
            } else if (this.state == 'ended') {
                this.player.play();
                return;
            } else if (this.state == 'ready') {
                const video_file = this.video.video_file || this.video.original_filename;
                const extension = this.getVideoExtension(video_file);
                const mimeType = this.getMimeTypeFromExtension(extension);

                const vid = {
                    withCredentials: false,
                    type: mimeType,
                    src: video_file
                };

                this.player.src(vid);
                this.player.play();
                this.isActivated = true;

                if (extension == '.webm' && this.video_initial_duration > 0) {
                    this.player.currentTime(this.video_initial_duration + 1);
                    this.can_play = false;
                    this.$emit('playable', false);
                    this.getVideoDuration(seekTo);
                    return;
                }
                this.$emit('playable', true);

                if (seekTo !== null) {
                    this.player.currentTime(seekTo);
                }
            } else {
                console.error('Cannot play, unknown state: ' + this.state);
            }
        },

        getVideoDuration(_seekTo = null) {
            const observer = setInterval(() => {
                const duration = this.player.duration();
                if (isFinite(duration)) {
                    this.hasVideoDuration(_seekTo)
                    clearInterval(observer);
                }
            }, 300);
        },
        hasVideoDuration(_seekTo = null) {
            this.can_play = true
            this.$emit('playable', true)
            if (_seekTo != null) {
                this.player.currentTime(_seekTo)
            } else {
                this.player.currentTime(0)
            }
        },

        getVideoExtension(url) {
            try {
                const pathname = new URL(url).pathname; // e.g. /videos/e4bf56a2/2034-399sotrtna9_1678375829.mkv
                const filename = pathname.split('/').pop(); // e.g. 2034-399sotrtna9_1678375829.mkv
                const ext = filename.includes('.') ? '.' + filename.split('.').pop() : null;
                return ext;
            } catch (e) {
                console.error('Invalid URL', e);
                return null;
            }
        },
        getMimeTypeFromExtension(extension) {
            const map = {
                '.mp4': 'video/mp4',
                '.webm': 'video/webm',
                '.ogg': 'video/ogg',
                '.ogv': 'video/ogg',
                '.mkv': 'video/x-matroska', // Not officially supported by all browsers
                '.mov': 'video/quicktime',  // May have limited support
                '.avi': 'video/x-msvideo',
                'm4v': 'video/x-m4v',
            };
            return map[extension.toLowerCase()] || 'video/mp4'; // default fallback
        },
        reset: function () {
            this.player.reset();
            this.state = 'ready';
        },
        updateViews: function () {
            if (this.alreadyReadCount) {
                return
            }
            this.alreadyReadCount = true
            //if (this.video.user) {

            if (this.$page.props.user == null) {
                const source_details = this.video.source_details
                const ip = source_details.ip ?? null
                if (this.$page.props.ip != ip) {
                    this.updateCountAnonymousViews();
                }
                //this.alreadyReadCount = true
                return
            }

            // }
            // if (this.alreadyReadCount || this.godview || this.visitor) {
            //     return;
            // }
            let url = this.$page.props.api_url + '/v1/video/views/' + this.video.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    this.alreadyReadCount = true;
                    // this.EventBus.emit('viewed', '');
                })
                .catch(e => {
                    console.log(e);
                });
        },
        updateCountAnonymousViews: function () {
            let url = this.$page.props.api_url + '/v1/video/visits/' + this.video.id;
            var params = {
                visitor: 'yes',
            };
            //console.log("updateCountAnonymousViews")
            axios.post(url, params)
                .then(response => {
                    //console.log("updateCountAnonymousViews response", response)
                    this.alreadyReadCount = true;
                    //this.$eventBus.$emit('viewed','');
                })
                .catch(e => {
                    console.log(e);
                });
        },
        action_download_wait: function () {
            this.waiting_download = true;
            let timeout_message = setTimeout(function () {
                this.waiting_download = false; // auto hide after 3 seconds
            }.bind(this), 3000);
        },
        action_download_test: function (display = true) {
            this.waiting_download = display;
        }
    },

    computed: {
        player() {
            return this.$refs.videoPlayer.player
        },
        teamslug: function () {
            if (this.$page.props.user) {
                if (this.$page.props.user.current_team) {
                    return this.$page.props.user.current_team.slug;
                }
            } else if (this.the_team_slug) {
                return this.the_team_slug;
            }
            return '';
        },
        mailtoOwnerLink() {
            let domain = this.$page.props.app_url.split('.').slice(-2).join('.')
            return 'mailto:' + this.team_owner_email + '?subject=' + this.$page.props.app_name + ' recording is not accessible - please upgrade&cc=' + this.team_admins + '&body=This recording is not accessible: ' + this.video.sharing_link + '%0D%0A %0D%0A Unlock it by visiting https://app.' + domain + '/subscription and upgrade your account. %0D%0A %0D%0A --- %0D%0A%0D%0A %0D%0A '

        }
    }
}

</script>

<style scoped>
.player {
    position: absolute !important;
    width: 100%;
    height: 100%;
}

.vjs-custom-skin {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.vjs-custom-skin /deep/ .video-js {
    width: 100%;
    height: 100%;
}

.vjs-custom-skin .video-js .vjs-control.vjs-progress-control {
    flex: auto !important;
}


.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}

.video-item .video-box .play {
    position: absolute;
    width: 80px;
    height: 80px;
    background: transparent url(/img/play-rounded-overlay.svg) no-repeat;
    opacity: .5;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transition: opacity .2s, width .2s, height .2s;
    background-size: cover;
}

.video-item .video-box .play:hover {
    opacity: 1;
    width: 74px;
    height: 74px;
}

.video-item .video-box .play.locked {
    background: url(/img/locked-circle.svg) no-repeat center center;
}

.video-item .video-box .img {
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 100%;
    height: 100%;
}

.video-item .video-box .img.gif {
    /* opacity: 0; */
    -moz-transition: opacity 0.2s ease-out;
    -webkit-transition: opacity 0.2s ease-out;
    transition: opacity 0.2s ease-out;
}

.video-item .video-box:hover .img.gif {
    opacity: 1;
}

.video-item .video-box .img.gif .gif-overlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
}

.lockedMsg {
    position: absolute;
    width: 100%;
    top: 0;
    padding: 20px;
    background: rgba(255, 246, 0, 0.9);
    color: #111;
    text-align: center;
    font-size: 105%;
    z-index: 9999;
}

.lockedMsg a {
    color: #111;
    text-decoration: underline;
}





.vjs-custom-skin .vjs-paused .vjs-big-play-button {
    display: none !important;
}

img.video-playpause-overlay {
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    /* transition: all 1s ;
        -moz-transition: all 1s ;
        -ms-transition: all 1s ;
        -webkit-transition: all 1s ;
        -o-transition: all 1s ; */
    opacity: 0;
}

img.video-playpause-overlay.show {
    animation-duration: 0.6s;
    animation-name: overlay;
}

@keyframes overlay {

    /*0% {
            transform: scale(0.5);
            -moz-transform: scale(0.5);
            -webkit-transform: scale(0.5);
            -o-transform: scale(0.5);
            -ms-transform: scale(0.5);
            opacity: 0;
        }*/
    0% {
        transform: scale(0.5);
        -moz-transform: scale(0.5);
        -webkit-transform: scale(0.5);
        -o-transform: scale(0.5);
        -ms-transform: scale(0.5);
        opacity: 1;
    }

    100% {
        transform: scale(1.5);
        -moz-transform: scale(1.5);
        -webkit-transform: scale(1.5);
        -o-transform: scale(1.5);
        -ms-transform: scale(1.5);
        opacity: 0;
    }
}
</style>
